import axios from "../config/axios-chatbot";
import qs from "qs";

export const ConversationRepository = {
    getResponseTime: ({
                          flowUid,
                          start,
                          end,
                          signal
                      }) => {
        const params = new URLSearchParams({flow: flowUid});
        if (start) params.append("start", start);
        if (end) params.append("end", end);
        return axios.get(`/api/conversation/statistics/response-time?${params.toString()}`, {signal});
    },
    getStatusStatistic: ({flowUid, type, startDate, endDate, signal}) =>
        axios.get(`/api/conversation/statistics/status`, {
            params: {
                flow: flowUid,
                type,
                start: startDate,
                end: endDate
            },
            signal
        }),
    getConversations: ({...params}) =>
        axios.get(`/api/conversation`, {
            params: {...(params || {})},
            paramsSerializer: (params) =>
                qs.stringify(params, {arrayFormat: "repeat"}), // <-- key fix
        }),
    getConversation: ({id}) => axios.get(`/api/conversation/${id}`),
    getPrevAndNext: ({id, ...params}) => axios.get(`/api/conversation/${id}/navigation`, {params: {...(params || {})}}),
    handoverToAgent: ({id, username, vdn, ...params}) => axios.post(`/api/conversation/${id}/handover`, {
        id: id,
        username: username,
        vdn: vdn
    }),
    toggleResolved: ({id}) => axios.post(`/api/conversation/${id}/toggle-resolve`),
    monitorConversation: ({id, username, ...params}) => axios.post(`/api/conversation/${id}/monitoring`, {
        id: id,
        username: username
    }),
    initiateConversation: ({
                               body,
                               params
                           }) => axios.post(`/api/conversation/call-over`, body, {params: {...(params || {})}}),
    getMessages: (id, signal, protectionToken) => axios.get(`/api/conversation/${id}/messages`, {
        signal,
        headers: protectionToken ? {"X-Protection-Token": protectionToken} : {}
    }),
    getCustomerDetails: (phoneNumber) => axios.get(`/api/customer?phoneNumber=${phoneNumber}`),
    updateCustomer: (body) => axios.post(`/api/customer`, {...(body || {})}),
    getHistory: ({id, caller, type, page, size}) => axios.get(`/api/conversation/history`, {
        params: {
            id,
            caller,
            type,
            page,
            size
        }
    }),
    createConversation: (data) => axios.post("/api/conversation", data),
    sendMessage: ({id, message}) => axios.post(`/api/conversation/${id}/send`, {message, conversation: id}),
    getNodeUsage: (ids) => {
        const query = ids.map(id => `ids=${encodeURIComponent(id)}`).join('&');
        return axios.get(`/api/conversation/statistics/node-usage?${query}`)
    },
    getTagsUsage: (data) => {
        return axios.post(`/api/conversation/statistics/tags-count`, {...data})
    },
    likeConversation: ({id, likeType, username}) => axios.post(`/api/conversation/${id}/interactions/likes`, {
        likeType,
        username
    }),
    removeLike: ({id, likeId}) => axios.delete(`/api/conversation/${id}/interactions/likes/${likeId}`),

    commentConversation: ({id, text, username}) => axios.post(`/api/conversation/${id}/interactions/comments`, {
        text,
        username
    }),
    removeComment: ({id, commentId}) => axios.delete(`/api/conversation/${id}/interactions/comments/${commentId}`),

}